/**
 * Common typography configuration for copy content on the Elevator site.
 *
 * Defines shared font families and weights used to build the MUI typography theme.
 */
const typographyVariables = {
  headers: {
    fontWeight: 700,
    fontFamily: 'Open Sans, sans-serif',
    lineHeight: 1.4,
  },
  body: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    fontSize: '16px',
  },
  subtitles: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  overlines: {
    fontFamily: 'Roboto, sans-serif',
    lineHeight: 1,
  },
} as const;

/**
 * MUI typography configuration for the Elevator design system.
 *
 * Overrides default typography variants (h1–h6, body1, body2, subtitle1, subtitle2)
 * to use the fonts and weights defined in `typographyVariables`.
 */
const typographyConfig = {
  typography: {
    h1: {
      ...typographyVariables.headers,
      fontSize: '2.027rem', // 40px base
    },
    h2: {
      ...typographyVariables.headers,
      fontSize: '1.802rem', // 32px base
    },
    h3: {
      ...typographyVariables.headers,
      fontSize: '1.602rem', // 28px base
    },
    h4: {
      ...typographyVariables.headers,
      fontSize: '1.424rem', // 24px base
    },
    h5: {
      ...typographyVariables.headers,
      fontSize: '1.266rem', // 20px base
    },
    h6: {
      ...typographyVariables.headers,
      fontSize: '1.125rem', // 16px base
    },
    body1: {
      ...typographyVariables.body,
      lineHeight: 2,
    },
    body2: {
      ...typographyVariables.body,
      lineHeight: 1.5,
    },
    subtitle1: {
      ...typographyVariables.subtitles,
    },
    subtitle2: {
      ...typographyVariables.subtitles,
    },
    overline1: {
      ...typographyVariables.overlines,
      fontWeight: 700,
      textTransform: 'uppercase' as const,
      fontSize: '0.889rem',
    },
    overline2: {
      ...typographyVariables.overlines,
      fontSize: '0.79rem',
    },
  },
};

export default typographyConfig;
